import React, { Component } from 'react'
import FeedbackTable from '../../containers/trip-feedbacks/TripFeedbackTable'
import Select from 'react-select'
import * as moment from 'moment'
import { ITripFilters, IServiceObject } from 'src/types'
import { feedbackStatusOption, feedbackTypeOptions, feedbackUserOption } from 'src/constants/trip'
import Calendar2 from '../icons/ui/Calendar2'
import Search2 from '../icons/ui/Search2'
import { Datepicker } from '@mobiscroll/react'

interface ITripsFilterControlsProps {
  orgId: string
  productIds: string[]
  updateTripFilters: (params: ITripFilters) => Promise<any>
  updateTripFiltersService: (params: ITripFilters) => Promise<any>
  filters: ITripFilters
  type: 'provider' | 'organization'
  services: IServiceObject[]
  onComponentMount: (organizationId: string, type: string) => void
}

export default class DriverFeedbackTabelPane extends Component<ITripsFilterControlsProps> {
  public state = {
    selectService: '',
    selectType: feedbackTypeOptions[0],
    selectUser: feedbackUserOption[0],
    selectFeedbackStatus: feedbackStatusOption[0],
    inputSearchFeedback: '',
    fromDate: moment()
      .startOf('day')
      .subtract(7, 'days')
      .format('MM/DD/YYYY hh:mmA'),
    toDate: moment()
      .endOf('day')
      .format('MM/DD/YYYY hh:mmA')
  }
  public searchFeedback = (e: any) => {
    this.setState({ inputSearchFeedback: e.target.value })
    this.props.updateTripFilters({
      search: e.target.value
    })
  }
  public handleChangeType = (selectedOption: any) => {
    this.setState({ selectType: selectedOption })
    this.props.updateTripFilters({ feedbackType: selectedOption.value })
  }
  public handleChangeService = (selectedOption: any) => {
    this.setState({ selectService: selectedOption })
    this.props.updateTripFilters({ serviceId: selectedOption.value })
  }
  public handleChangeUser = (selectedOption: any) => {
    this.setState({ selectUser: selectedOption })
    this.props.updateTripFilters({ userType: selectedOption.value })
  }
  public handleChangeFeedbackStatus = (selectedOption: any) => {
    this.setState({ selectFeedbackStatus: selectedOption })
    this.props.updateTripFilters({ feedbackStatus: selectedOption.value })
  }
  public handleFilterDateRange = (type: string, value: Date) => {
    const stateProperty = type === 'fromDate' ? 'fromDate' : 'toDate'
    const tripFiltersProperty = type === 'fromDate' ? 'timeStart' : 'timeEnd'
    this.setState({ [stateProperty]: value })
    this.props.updateTripFilters({ [tripFiltersProperty]: moment(value).toISOString() })
  }

  public componentDidMount() {
    this.props.updateTripFilters({
      feedbackType: this.state.selectType.value,
      userType: this.state.selectUser.value,
      feedbackStatus: this.state.selectFeedbackStatus.value,
      timeStart: moment()
        .startOf('day')
        .subtract(7, 'days')
        .toISOString(),
      timeEnd: moment()
        .endOf('day')
        .toISOString()
    })
    this.props.onComponentMount(this.props.orgId, 'active')
  }

  public render() {
    const Service = this.props.services.map(p => {
      return { label: p.name, value: p.id }
    })

    const { selectType, selectUser, selectService, selectFeedbackStatus } = this.state

    const inputPropFrom = {
      id: 'date-from',
      placeholder: 'From'
    }
    const inputPropTo = {
      id: 'date-to',
      placeholder: 'To'
    }

    return (
      <div className='pt3'>
        <div className='flex flex-row col-12 filter-field-section'>
          {/* First Row */}
          <div className='filter-field col-9 flex flex-row items-center justify-around'>
            <div className='col-3 filter-field'>
              <label>Type</label>
              <Select
                className='mt1 filter-field-container'
                value={selectType}
                options={feedbackTypeOptions}
                onChange={this.handleChangeType}
              />
            </div>
            <div className='col-3 filter-field'>
              <label>User</label>
              <Select
                className='mt1 filter-field-container'
                value={selectUser}
                options={feedbackUserOption}
                onChange={this.handleChangeUser}
              />
            </div>
            <div className='col-3 filter-field'>
              <label>Service</label>
              <Select
                className='mt1 filter-field-container'
                options={Service}
                value={selectService}
                onChange={this.handleChangeService}
              />
            </div>
            <div className='col-9 filter-field'>
              <label>Date Range</label>
              <div className='col-12 flex mt1'>
                <div className='filter-field-container date col-6 mr1'>
                  <Datepicker
                    controls={['calendar', 'time']}
                    dateFormat='MM/DD/YYYY'
                    inputProps={{
                      className: 'border-none outline-none w100',
                      ...inputPropFrom
                    }}
                    timeFormat='hh:mmA'
                    value={this.state.fromDate}
                    onChange={({ value }) => this.handleFilterDateRange('fromDate', value)}
                  />
                  <Calendar2 className='icon--20x20 cursor--pointer' />
                </div>

                <div className='filter-field-container date col-6'>
                  <Datepicker
                    controls={['calendar', 'time']}
                    dateFormat='MM/DD/YYYY'
                    inputProps={{
                      className: 'border-none outline-none w100',
                      ...inputPropTo
                    }}
                    min={moment(this.state.fromDate)}
                    timeFormat='hh:mmA'
                    value={this.state.toDate}
                    onChange={({ value }) => this.handleFilterDateRange('toDate', value)}
                  />
                  <Calendar2 className='icon--20x20 cursor--pointer' />
                </div>
              </div>
            </div>
            <div className='col-3 filter-field'>
              <label>Status</label>
              <Select
                className='mt1 filter-field-container'
                value={selectFeedbackStatus}
                options={feedbackStatusOption}
                onChange={this.handleChangeFeedbackStatus}
              />
            </div>
          </div>
          {/* First Row */}

          {/* Second Row */}
          <div className='filter-field search-outer col-3 flex flex-row items-center justify-around'>
            <div className='filter-field filter-field-container search'>
              <input
                id='search-field'
                type='text'
                placeholder='Search by Trip ID, Rider Name etc'
                onChange={this.searchFeedback}
              />
              <label htmlFor='search-field'>
                <Search2 className='ml1 icon--20x20 cursor--pointer' />
              </label>
            </div>
          </div>
          {/* Second Row */}
        </div>

        <div className='mt2'>
          <FeedbackTable searchFilter={this.state.inputSearchFeedback} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/trip-feedbacks/TripFeedbackTablePane.tsx